import firebase from "../firebase";

export async function GoogleAuth() {
  try {
    const auth = firebase.auth();
    const provider = new firebase.auth.GoogleAuthProvider();
    console.log(provider);

    const currentUser = await auth.signInWithPopup(provider);
    const idToken = await auth.currentUser.getIdToken(true);

    return { user: currentUser.user, idToken: idToken, error: null };
  } catch (error) {
    console.log("social-auth.js -> GoogleAuth: " + error);
    return {
      user: null,
      idToken: null,
      error: "Not able to sign in with Google!"
    };
  }
}
